import React from "react"
import { Helmet } from "react-helmet";
import { Container, Box, CardMedia, Typography } from '@mui/material';
import { Assets } from "../../../assets/Assets";
import PageHeader from "../../../component/header/page";
import "./style.css";
const AboutUs = () => {
    return (
        <>
            <Helmet>
                <meta name="title" content='About - Pickzon Dating App' />
                <title>About - Pickzon Dating App</title>
                <meta name="description" content='Join Pickzon for genuine connections—dating, travel buddies, or friends—all verified with gesture selfies. Real people, real connections.' />
                <meta name="keyword" content='About Pickzon, Pickzon About us, Pickzon' />
                <meta property='og:title' content='About - Pickzon Dating App' />
                <meta property='og:image' content={`https://www.pickzon.com${Assets.aboutUsImg.img}`} />
                <meta property='og:description' content='Join Pickzon for genuine connections—dating, travel buddies, or friends—all verified with gesture selfies. Real people, real connections.' />
                <meta property='og:url' content={`https://www.pickzon.com/about`} />
            </Helmet>
            <Container maxWidth="" disableGutters={true} >
                <Box sx={style.aboutBox} >
                    <PageHeader sx={{ fontSize: 38, textTransform: "uppercase", fontWeight: 800, fontFamily: 'Poppins-Black', paddingBottom: '4vh' }} content="ABOUT US" />
                    <CardMedia component="img" image={Assets.aboutUsImg.img} alt={Assets.aboutUsImg.alt} />
                    <Box fontFamily={"Roboto"} paddingTop={3} paddingLeft={{ xs: 2, md: 10 }} paddingRight={{ xs: 2, md: 10 }}>
                        <Typography sx={style.content}>
                            Once upon a time, in the world of endless swipes and ghosted texts, Pickzon was born. We wanted more than just another dating app—we wanted something real. So, we decided to make it happen. Picture this: when you sign up, you snap a quick gesture selfie, ensuring everyone you meet is genuine. No more guessing games, just real people ready to connect.
                        </Typography>
                        <Typography sx={style.content}>
                            But here’s the twist—Pickzon isn’t just for finding dates. Whether you’re on the hunt for a travel buddy to share new adventures or a friend to chat with about your latest binge-watch obsession, we’ve got you. We’re all about matching you with people who share your interests, so your connections feel as natural as they come.
                        </Typography>
                        <Typography sx={style.content}>
                            So, if you’re ready to step into a world where real connections matter, you’ve come to the right place. Let’s start something special together!
                        </Typography>
                    </Box>
                </Box>
            </Container>
        </>
    )
};

export default AboutUs;

const style = {
    aboutBox: {
        borderRadius: 6,
        paddingTop: 2,
        paddingLeft: { xs: 2, md: 7 },
        paddingRight: { xs: 2, md: 7 }
    },
    content: {
        fontFamily: 'Roboto',
        color: '#666666',
        fontWeight: '400',
        lineHeight: 2,
        paddingBottom: '3vh'
    },
    customeTitle: {
        fontFamily: 'Poppins-Black'
    }
};